export const exteriorView05ImageOptions = {
	angle:"ExteriorView05",
	staticOptions:{
		HullColorways:1,
		Bowsprit:1,
		HullTreatment:1,
		TeakDeck:1,
		TeakOnSideDecks:1,
		BathingPlatform:1,
		SelfTacker:1,
		TeakOnCoachRoof:1,
		MastAndBoom:1,
		BoomCover:1,
		OutboardBracket:1,
		CockpitBenchExtentions:1,
		CockpitCushionBackrests:1,
		CockpitCushionSeats:1,
		CockpitFabric:1,
		SprayhoodFabric:1,
		GTSeat:1,
		Flag:1,
	},
	mattes:[
		{
			option:"HullColorways",
			dependency:"Wheel"
		},
		{
			option:"HullTreatment",
			dependency:null
		},
		{
			option:"TeakDeck",
			dependency:"Wheel"
		},
		{
			option:"TeakOnSideDecks",
			dependency:["TeakDeck", "Wheel"]
		},
		{
			option:"BathingPlatform",
			dependency:["HullColorways", "TeakDeck"]
		},
		{
			option:"OutboardBracket",
			dependency:null
		},
		{
			option:"CockpitBenchExtentions",
			dependency:["TeakDeck", "Wheel", "CockpitFabric"]
		},
		{
			option:"CockpitCushionBackrests",
			dependency:"CockpitFabric"
		},
		{
			option:"CockpitCushionSeats",
			dependency:["CockpitBenchExtentions", "CockpitFabric"]
		},
		{
			option:"CockpitFabric",
			dependency:null
		},
		{
			option:"SprayhoodFabric",
			dependency:"CockpitCushionBackrests"
		},
		{
			option:"GTSeat",
			dependency:"CockpitFabric"
		},
	],
	overlays:[
	]
};



// WEBPACK FOOTER //
// ./src/X46MK2/views/ExteriorView05.js